const IconPlay = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3992 6.60367C13.4659 7.22426 13.4659 8.77572 12.3992 9.3963L2.79922 14.9816C1.73255 15.6022 0.399219 14.8264 0.399219 13.5853L0.399219 2.41472C0.399219 1.17355 1.73255 0.397818 2.79922 1.0184L12.3992 6.60367Z"
        fill="white"
      />
    </svg>
  );
};

export default IconPlay;
